export const SrpPaymentCalculator = {
  props: ['price', 'lease-data', 'finance-data', 'lang','province-tax-value','frequencySelected', 'customDownPayment'],
  data () {
    return {
      termActive: this.frequencySelected ? this.frequencySelected : 'weekly',
      startingPrice: this.price,
      tradeInValue: 0,
      downPayment: this.customDownPayment ? this.customDownPayment : 0,
      isTaxed: false,
      leaseRate: 0,
      leaseTerm: 0,
      leaseResidual: 0,
      financeRate: 0,
      financeTerm: 0,
    }
  },
  methods: {
    usdFormat(value){
      var formatter = new Intl.NumberFormat(this.lang, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        currencyDisplay: 'narrowSymbol'
    });
      return formatter.format(value);
    },

    onFocus(value) {
      if (value == 'downPayment' && this.downPayment == 0)  this.downPayment = null;
      if (value == 'tradeInValue' && this.tradeInValue == 0) this.tradeInValue = null;
    },

    blur(value) {
      if (value == 'downPayment' && this.downPayment == '')  this.downPayment = 0;
      if (value == 'tradeInValue' && this.tradeInValue == '') this.tradeInValue = 0;
    },

    setActive(btn) {
      this.termActive = btn;
    },

    handleTradeInValue() {
      let tradeValue = Number(this.tradeInValue);
      let downPayment = Number(this.downPayment);

      if (tradeValue < 0) {
        this.startingPrice = this.startingPrice;
      } else {
        this.startingPrice = this.price - tradeValue - downPayment;
      }
    },

    handleDownPayment() {
      let downPayment = Number(this.downPayment);
      let tradeValue = Number(this.tradeInValue);

      if (downPayment < 0) {
        this.startingPrice = this.startingPrice;
      } else {
        let provinceTax = this.provinceTaxValue ? (1 + (this.provinceTaxValue / 100)) : 1.13;
        this.startingPrice = this.price - tradeValue - (downPayment / provinceTax);
      }
    },

    handleTax() {
      this.isTaxed = !this.isTaxed;
    },

    handleLeaseTerm(e) {
      this.leaseTerm = Number(e.target.value);
      this.getLeaseData();
    },

    handleFinanceTerm(e) {
      this.financeTerm = Number(e.target.value);
      this.getFinanceData();
    },

    getLeaseTotal(price, term, rate, residual, type) {
      let provinceTax = this.provinceTaxValue ? (1 + (this.provinceTaxValue / 100)) : 1.13;
      this.isTaxed ? price = price * provinceTax : price = price;

      let total = 0;
      let moneyFactor = (rate / 2400);
      let newResidual = price * (residual / 100);
      let depretiation = (price - (price * (residual / 100)) ) / term;
      let financeFee = (price + newResidual) * moneyFactor;
      let monthlyLease = financeFee + depretiation;

      if (type === 'weekly' || type === null) {
        total = Math.round((monthlyLease * 12) / 52);
      } else if (type === 'bi-weekly') {
        total = Math.round((monthlyLease * 12) / 26);
      } else {
        total = Math.round(monthlyLease);
      }
      return total;
    },

    getFinanceTotal(price, rate, term, type) {
      let provinceTax = this.provinceTaxValue ? (1 + (this.provinceTaxValue / 100)) : 1.13;
      this.isTaxed ? price = price * provinceTax : price = price;

      let total = Math.round( (price * (rate / 1200) * Math.pow(1 + (rate / 1200), term)) / ( Math.pow(1 + (rate / 1200), term) -1 ) * 100 ) / 100;
      total = Math.round(total, 2 );
      if (type === 'weekly' || type === null) {
        total = Math.floor(((total * 12) / 52))
      } else if (type === 'bi-weekly') {
        total = Math.floor(((total * 12) / 26))
      } else {
        total = total;
      }
      return total;
    },

    getLeaseData() {
      // Get Residual
      if(Array.isArray(this.leaseData)) {
        this.leaseData.forEach(item => {
          if(item.term === this.leaseTerm) this.leaseResidual = item.residual;
        });
      } else {
        this.leaseResidual = this.leaseData.residual;
      }

      // Get Rate
      if(Array.isArray(this.leaseData)) {
        this.leaseData.forEach(item => {
          if(item.term === this.leaseTerm) this.leaseRate = item.rate;
        });
      } else {
        this.leaseRate = this.leaseData.rate;
      }
    },

    getFinanceData() {
      // Get Rate
      if(Array.isArray(this.financeData)) {
        this.financeData.forEach(item => {
          if(item.term === this.financeTerm) this.financeRate = item.rate;
        });
      } else {
        this.financeRate = this.financeData.rate;
      }
    },
    atumCalculatorRange() {
      this.getFinanceTotal();
      this.getLeaseTotal();
    }
  },
  mounted() {
    this.$nextTick(function () {
      if(document.getElementById('lease-months') !== null)
        this.leaseTerm = Number(document.getElementById('lease-months').value);
      else
        this.leaseTerm = 0;

      if(document.getElementById('finance-months') !== null)
        this.financeTerm = Number(document.getElementById('finance-months').value);
      else
        this.financeTerm = 0;

      this.getLeaseData();
      this.getFinanceData();

    });

    this.handleDownPayment();

        /**
     * It takes the value of the input and uses it to set the background size of the input
     * @param e - The event object.
     */
        const rangeInputs = document.querySelectorAll('input[type="range"].atum-input-range')
        const numberInputs = document.querySelectorAll('input[type="number"].atum-input-number')

        if (!rangeInputs.length && !numberInputs.length) {
          return;
        }

        function handleInputChange(e) {
          let target = e.target
          if (e.target.type !== 'range') {
            target = document.getElementById('range')
          }
          const min = target.min
          const max = target.max
          const val = target.value

          target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%'
        }

        [...rangeInputs, ...numberInputs].forEach(input => {
          input.addEventListener('input', handleInputChange)
        })


        /* Calling the handleInputChange function with the first rangeInputs element as the target. */
        for (let i = 0; i < rangeInputs.length; i++) {
          handleInputChange({ target: rangeInputs[i] });
        }
  },
  computed: {
    calculateLease() {
      return this.getLeaseTotal(this.startingPrice, this.leaseTerm, this.leaseRate, this.leaseResidual, this.termActive);
    },
    calculateFinance() {
      return this.getFinanceTotal(this.startingPrice, this.financeRate, this.financeTerm, this.termActive);
    }
  },
  watch: {}
}
